import request from '@/utils/request'
const context = require('../context')
const qs = require('qs');

export function fetchDishesList(params) {
    return request({
			url: context.CATERING + '/dishes/queryPageByParam',
			method: 'get',
			params: params,
			paramsSerializer: function (params) {
				return qs.stringify(params, { arrayFormat: 'repeat' ,skipNulls: true})
			}
    })
}

export function querySimpleDishesByKeyWord(params) {
	return request({
		url: context.CATERING + '/dishes/querySimpleByKeyword',
		method: 'get',
		params: params
})
}

export function queryDishesDetail(params) {
	return request({
			url: context.CATERING + '/dishes/query/'+ params,
			method: 'get'
	})
}

export function queryIngredientsList(dishesId,crowdDictValue) {
	return request({
			url: context.CATERING + '/dishes/queryIngredientsList/'+ dishesId+'/'+crowdDictValue,
			method: 'get'
	})
}

export function queryLikeDishes(params) {
	return request({
			url: context.CATERING + '/dishes/queryLikeDishes',
			method: 'get',
			params: params
	})
}

export function saveDishes(data) {
	return request({
		url: context.CATERING + '/dishes/save',
		method: 'post',
		data: data
	})
}

export function updateDishes(data) {
	return request({
		url: context.CATERING + '/dishes/update',
		method: 'post',
		data: data
	})
}

export function updateExt(data) {
	return request({
		url: context.CATERING + '/dishes/update/ext',
		method: 'post',
		data: data
	})
}


// WEBPACK FOOTER //
// ./src/api/catering/dishes.js